<template>
    <div id="datetime_setup">
        <v-card style="margin-top: 20px" id="datetime-card">
            <v-card-title>
              <span class="main_card_title">{{ $i18n.t('pages.system.datetime_settings.date_and_time_settings') }}</span>
            </v-card-title>
            <v-card-text>
              <div style="display: flex; justify-content: flex-start">
                <date-picker
                    class="datetime_input"
                    :formatted_date="date_for_textfield"
                    :placeholder="$i18n.t('pages.vehicles_lists.dialog.date')"
                    :disabled="ntp_sync === true"
                    @input_date="input_new_date"
                />
                <time-picker
                    class="datetime_input"
                    :time="time_for_textfield"
                    :placeholder="$i18n.t('pages.vehicles_lists.dialog.time')"
                    :width="'100%'"
                    :disabled="ntp_sync === true"
                    @save_time="input_new_time"
                />
                  <v-autocomplete
                      class="datetime_input rounded_8px height_56px"
                      ref="timezone_ref"
                      v-model="system_timezone"
                      :items="$store.state.timezones"
                      :label="$i18n.t('pages.system.datetime_settings.select_timezone')"
                      outlined
                      @change="update_timezone"
                    >
                  </v-autocomplete>
              </div>
              <div style="display: flex; flex-direction: column;">
                <v-checkbox
                      v-model="ntp_sync"
                      :label="$i18n.t('pages.system.datetime_settings.ntp_synchronization')"
                      @change="sync_with_ntp"
                />

                <div style="display: flex; justify-content: space-between">
                  <div style="display: flex; justify-content: flex-start">
                    <v-btn
                        :disabled="ntp_sync"
                        class="white--text mr-1 ml-1 datetime-button"
                        color="#DBEAF1"
                        elevation="0"
                        height="42"
                        @click="sync_datetime_with_browser"
                    >
                      <span class="main_color button-font">{{ $i18n.t('pages.system.datetime_settings.browser_synchronization') }}</span>
                    </v-btn>
                  </div>

                  <div v-show="new_date_is_set || new_time_is_set" style="display: flex; justify-content: flex-end">
                    <v-btn
                      class="white--text width-170 mr-1 ml-1"
                      height="42"
                      color="#DBEAF1"
                      elevation="0"
                      @click="finish_datetime_change"
                    >
                      <span style="color: #207EA9" class="button-font">{{ $i18n.t('general.cancel') }}</span>
                    </v-btn>

                    <v-btn
                        class="white--text width-170 mr-1 ml-1"
                        height="42"
                        elevation="0"
                        color="#207ea9"
                        @click="set_new_datetime"
                    >
                      <span>{{ $i18n.t('general.save') }}</span>
                    </v-btn>
                  </div>

                </div>
              </div>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import store from "@/store";
// import {EventBus} from "@/bus";
import {mapActions, mapGetters} from "vuex";

import moment from 'moment'
import 'moment-timezone'
import {i18n} from "@/i18n";
import TimePicker from "@/custom_components/TimePicker";
import DatePicker from "@/custom_components/DatePicker";

export default {
    name: "DateTimeSetup",
  components: {DatePicker, TimePicker},
  data: function () {
      // EventBus.$on('ws_on_message', this.ws_on_message)
      this.fetch_data()
      return {
        store,
        ntp_sync: false,

        datetime_change_dialog: false,
        current_system_date: '',
        current_system_time: '',

        new_system_date: '',
        new_system_time: '',
        new_date_is_set: false,
        new_time_is_set: false,
        new_system_datetime_formatted: '',

        date: '',
        system_timezone: '',

        alert: false,
        alert_text: '',

      }
    },
    methods: {
      fetch_data: function () {
        this.$http({url: this.$http_hostname + '/system_settings/get_datetime_info', method: 'GET'})
        .then(resp => {
          this.ntp_sync = resp.data.ntp_sync
          this.system_timezone = resp.data.current_timezone
        })
        .catch(() => {
          this.setSnackbar({
            text: i18n.t('notifications.error_during_data_loading'),
          })
        })
      },
      sync_datetime_with_browser: function() {
        let browser_date = new Date()
        let browser_timezone = this.$store.state.current_browser_timezone
        this.set_system_datetime(browser_date, browser_timezone)
      },
      set_system_datetime: function (date, timezone=null) {
        let data = {'date': date.toJSON(), 'timezone': timezone}
        this.$http({url: this.$http_hostname + '/system_settings/set_system_datetime', data: data, method: 'POST'})
        .then(resp => {
            console.log(resp)
            this.finish_datetime_change()
        })
        .catch(() => {
            this.setSnackbar({
              text: i18n.t('notifications.system.couldnt_set_datetime'),
            })
        })
      },

      sync_with_ntp: function () {
        let data = {'ntp_sync': this.ntp_sync}
        this.$http({url: this.$http_hostname + '/system_settings/ntp_sync', data: data, method: 'POST'})
            .then(() => {
              this.setSnackbar({
                text: this.ntp_sync ? i18n.t('notifications.system.ntp_sync_is_on'): i18n.t('notifications.system.ntp_sync_is_off'),
              })
            })
            .catch(() => {
              this.setSnackbar({
                text: i18n.t('notifications.system.couldnt_sync_with_ntp'),
              })
            })
      },
      update_timezone: function () {
        let t = this
        let data = {'timezone': this.system_timezone}
        this.$http({url: this.$http_hostname + '/system_settings/update_timezone', data: data, method: 'POST'})
        .then(() => {
          t.$store.state.current_system_timezone = this.system_timezone
          this.setSnackbar({
            text: i18n.t('notifications.system.timezone_set', {timezone: this.system_timezone}),
          })
        })
        .catch(() => {
          this.setSnackbar({
            text: i18n.t('notifications.system.couldnt_set_timezone'),
          })
        })
      },
      set_new_datetime: function () {
        let date = ''
        let time = ''
        if (!this.new_system_date) {
          date = this.date_slash_to_hyphen(this.date_for_textfield).split('-')
        } else {
          date = this.new_system_date.split('-')
        }
        if (!this.new_system_time) {
          time = this.time_for_textfield.split(':')
        } else {
          time = this.new_system_time.split(':')
        }
        let year = parseInt(date[0]);
        let month = parseInt(date[1]) - 1;
        let day = parseInt(date[2]);
        let hours = parseInt(time[0]);
        let minutes = parseInt(time[1]);
        let seconds = parseInt(time[2])
        console.log(year, month, day, hours, minutes, seconds)
      // eslint-disable-next-line no-unused-vars
        let new_datetime = new Date(year, month, day, hours, minutes, seconds);
        this.set_system_datetime(new_datetime)
        // this.close_editor()
      },
      input_new_date: function (params) {
        this.new_date_is_set = true
        this.new_system_date = params.date
        console.log(this.new_system_date)
      },
      input_new_time: function (params) {
        this.new_time_is_set = true
        this.new_system_time = params.time + ':00'
        console.log(this.new_system_time)
      },
      date_hyphen_to_slash: function (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      date_slash_to_hyphen: function (date) {
        if (!date) return null
        const [day, month, year] = date.split('/')
        console.log(`${year}-${month}-${day}`)
        return `${year}-${month}-${day}`
      },

      func_moment_date: function (datetime_obj) {
        let datetime_in_server_tz = moment.tz(datetime_obj, store.state.current_system_timezone)
        return datetime_in_server_tz.clone().startOf('day').format('DD/MM/YYYY');
      },
      func_moment_time: function (datetime_obj) {
        let datetime_in_server_tz = moment.tz(datetime_obj, store.state.current_system_timezone)
        return datetime_in_server_tz.format('HH:mm:ss')
      },
      finish_datetime_change: function () {
        this.new_date_is_set = false
        this.new_time_is_set = false
        this.new_system_date = ''
        this.new_system_time = ''
      },

      ...mapActions(['setSnackbar'])
},
computed: {
    date_for_textfield () {
      return this.new_date_is_set ? this.date_hyphen_to_slash(this.new_system_date) : this.func_moment_date(this.systemDatetime)
    },
    time_for_textfield () {
      return this.new_time_is_set? this.new_system_time : this.func_moment_time(store.state.system_datetime)
    },
  ...mapGetters(['systemDatetime'])
},
beforeDestroy() {
      // EventBus.$off('ws_on_message')
}
}
</script>

<style scoped>

#datetime-card {
  background: #FFFFFF;
  box-shadow: 0px 3px 2px rgba(138, 138, 138, 0.15);
  border-radius: 8px;
}
.datetime_input {
  max-width: 300px;
  padding: 10px;
}
.main_color {
  color: #207EA9;
}
.datetime-button {
  height: 60px;
}
</style>